/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaModalBackdrop/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Children from 'Simple/Children'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TysiaModalBackdrop({
  children,
  viewPath = "/DesignSystem/TysiaModal/TysiaModalBackdrop",
  contentRef,
  top,
  left,
  closeOnClickOutside,
  onClose,
  isSelected
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtColorsOverlay400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.overlay.400'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  contentRef,
  top,
  left,
  closeOnClickOutside,
  onClose
  
})
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<div
  data-testid="TysiaModalBackdrop.Vertical"
  data-view-path={viewPath}
 id="modal-backdrop"
 ref={contentRef}
 closeOnClickOutside={closeOnClickOutside}
 onClose={onClose}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--t-1-1h8ge1': typeof top === 'number' ? `${top}px` : top,'--l-2-1h8ge1': typeof left === 'number' ? `${left}px` : left,'--bc-3-1h8ge1': dtColorsOverlay400,'--o-4-1h8ge1': isBefore ? 0 : 1}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</div>
)}
</FloatingPortal>
</React.Fragment>)
}